<ng-container *transloco="let t">
  <div class="flex h-full w-full flex-col gap-2">
    <div class="mt-2 flex justify-end">
      <button iButton variant="secondary" (click)="restoreColumns()">{{ t("common.restore_columns") }}</button>
    </div>
    <div class="ag-theme-quartz flex-1">
      <ag-grid-angular
        class="h-full w-full"
        [rowData]="gridData()"
        [gridOptions]="gridOptions"
        [statusBar]="STATUS_BAR"
      />
    </div>
  </div>
</ng-container>
